import React from 'react'
import { FormattedHTMLMessage } from '@web/walter-ui-kit'

import AllCoinsPreloader from './AllCoins/Preloader'
import CoinCollectionsPreloader from './CoinCollections/Preloader'
import { useAssetLimits, useCommonCMSConfig, useCurrencies, useProviders, useStakingUser, useSymbols } from '~api'
import { useFavorites } from '~hooks/useFavorites'
import PageHeader from '~components/PageLayout/PageHeader'
import { lang as navMenuLang } from '~components/App/Layout/NavigationMenu/lang'
import PageLayout from '~components/PageLayout'
import styles from '~pages/MarketPage/style.module.css'
import FilterPreloader from '~pages/MarketPage/AllCoins/FilterPreloader'

// TODO redesign: restyle

function Preloader() {
    const { showStaking } = useCommonCMSConfig().data?.features ?? {}

    useProviders()
    useAssetLimits()
    useStakingUser({ shouldRequest: showStaking })
    useFavorites()
    useCurrencies()
    useSymbols()

    return (
        <PageLayout
            contentWidth="xl"
            header={<PageHeader rootPage title={<FormattedHTMLMessage {...navMenuLang.market} />} />}
        >
            <div className={styles.wrap} data-pointer="market_page_prelaoder">
                <div className={styles.allCoins}>
                    <div className={styles.filters}>
                        <FilterPreloader />
                    </div>
                    <div className={styles.tables}>
                        <AllCoinsPreloader />
                    </div>
                </div>
                <div className={styles.dividerColumn} />
                <div className={styles.collections}>
                    <CoinCollectionsPreloader />
                </div>
            </div>
        </PageLayout>
    )
}

export default Preloader
